<template>
  <div>
    <div class="cont-xw clearfix">
      <div class="jg-head">产品图片</div>
      <div style="overflow: hidden" class="text-center">
        <div class="text-center">
          <img
            class="form-group col-md-6 col-xs-6 col-sm-6"
            style="float:none"
            src="../../common/images/RU02.jpg"
          />
          <div @click="riseup" class="btn btn-success btn-circle top text-center">上升</div>
          <div>
            <a href="#fast" type="button" class="btn btn-danger btn-circle download text-center">下载</a>
          </div>
        </div>
      </div>
      <div class="jg-head">产品概述</div>
      <p>IVF-RU02第一代UHF小精灵是一款便携式小型读卡器，可通过3.5mm耳机接口与ios、android等智能系统平台连接使用，改变原来超高频电子标签必须采用专用的读写设备，实现超高频读写器的微型化、低成本化、民用化，推动RFID应用系统工程真正的普及化。</p>
      <div class="jg-head">参数规格</div>
      <p>支持超高频（UHF）标签协议ISO18000-6C</p>
      <p>支持系统：Windows、IOS、Android</p>
      <p>通信接口：3.5mm音频接口（普通耳机接口）</p>
      <p>读取距离：50cm（视标签大小而定）</p>
      <p>工作时长：连续工作3小时，可查询3万次</p>
      <p>重量：35g</p>
      <p>电池容量：550mA</p>
      <p>充电方式：USB 5V/0.5A，充电2小时</p>

      <p>工作环境温度：-20℃~60℃</p>
      <div class="jg-head">指示灯状态</div>
      <p>中间灯:</p>
      <p>①、正常工作：绿灯长亮</p>
      <p>②、读到标签EPC：绿灯闪烁</p>
      <p>③、读到标签USER区数据：绿灯闪烁</p>
      <p>④、电量超低：绿灯一直快速闪烁（低电停止使用，无法读卡）</p>
      <p>⑤、设备异常：灯不亮</p>
      <p>⑥、电 量 低：绿灯一直缓慢闪烁（低电报警，请尽快充电）</p>
      <p>⑦、电量超低：绿灯一直快速闪烁（低电停止使用，无法读卡）</p>
      <p>⑧、充 电 中：红灯长亮</p>
      <p>⑨、充电完成：红灯灭掉</p>

      <div id="fast" class="jg-head">下载</div>
      <ul>
        <li class="form-group">
          <FileDownload href="/static/IVF-BU/IVF-RU02规格书.doc">产品规格书</FileDownload>
        </li>
        <li class="form-group">
          <FileDownload href="/static/SDK/RU01_SDK.rar">RU中性完整SDK下载</FileDownload>
        </li>

        <li class="form-group">
          <QRDownload></QRDownload>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FileDownload from "@/base/filedownload";
import QRDownload from "@/base/qrdownload";
import { riseup } from "@/common/js/riseup.js";
export default {
  data() {
    return {};
  },
  methods: {
    openmodal() {
      $(this.$refs.mymodal).modal("show");
    },

    riseup() {
        riseup()
      }
  },
  components: { FileDownload, QRDownload }
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/RU/02.vue